import { BehaviorSubject, Observable, Subject } from 'rxjs';

export abstract class AbstractFacade {
  public readonly store: Subject<any>;
}
